import React from 'react';

//MUI
import {makeStyles} from 'tss-react/mui';

import {createTheme, ThemeProvider} from '@mui/material/styles';
import Fade from '@mui/material/Fade';
import Modal from '@mui/material/Modal';

const theme = createTheme();
const useStyles = makeStyles()((theme) => ({
   modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
   },
   paper: {
      position: 'absolute',
      height: '95%',
      overflow: 'auto',
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3)
   },
   full: {
      width: '95%'
   },
   auto: {
      [theme.breakpoints.up('sm')]: {
         width: 'auto'
      }
   }
}));

function FullModal({autoWidth, id, ...props}) {
   const {classes, cx} = useStyles();
   return (
      <Modal
         id={id}
         open={props.open}
         onClose={props.onClose}
         className={classes.modal}
         aria-labelledby="simple-modal-title"
         aria-describedby="simple-modal-description"
      >
         <Fade in={props.open}>
            <div
               className={cx(classes.paper, classes.full, {
                  [classes.auto]: autoWidth
               })}
            >
               {props.children}
            </div>
         </Fade>
      </Modal>
   );
}

export default FullModal;
